// Metro Fibre packages
export const metrofibrePackages = [
  // FTTH Packages
  {
    ID: 3152222,
    Title: "Metro Fibre 75/75Mbps - MFN FTTH By Wondernet",
    Price: 749.00,
    "Download speed (kbps)": 76800,
    "Upload speed (kbps)": 76800,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 3152224,
    Title: "Metro Fibre 250/250Mbps - MFN FTTH By Wondernet",
    Price: 999.00,
    "Download speed (kbps)": 256000,
    "Upload speed (kbps)": 256000,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 3152226,
    Title: "Metro Fibre 400/400Mbps - MFN FTTH By Wondernet",
    Price: 1049.00,
    "Download speed (kbps)": 409600,
    "Upload speed (kbps)": 409600,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 12574019,
    Title: "Metro Fibre 500/500Mbps - MFN FTTH By Wondernet",
    Price: 1199.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 512000,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559824,
    Title: "Metro Fibre 25/25Mbps - MFN FTTH By Wondernet",
    Price: 499.00,
    "Download speed (kbps)": 25600,
    "Upload speed (kbps)": 25600,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559888,
    Title: "Metro Fibre 45/45Mbps - MFN FTTH By Wondernet",
    Price: 699.00,
    "Download speed (kbps)": 46080,
    "Upload speed (kbps)": 46080,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  
  // FTTB Packages
  {
    ID: 22559890,
    Title: "Metrofibre 20/20Mbps SME FTTB - Metrofibre By Wondernet",
    Price: 809.00,
    "Download speed (kbps)": 20480,
    "Upload speed (kbps)": 20480,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559891,
    Title: "Metrofibre 50/50Mbps SME FTTB - Metrofibre By Wondernet",
    Price: 1349.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559892,
    Title: "Metrofibre 100/100Mbps SME FTTB - Metrofibre By Wondernet",
    Price: 1779.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559893,
    Title: "Metrofibre 200/200Mbps SME FTTB - Metrofibre By Wondernet",
    Price: 2109.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559894,
    Title: "Metrofibre 500/500Mbps SME FTTB - Metrofibre By Wondernet",
    Price: 2729.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 512000,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559895,
    Title: "Metrofibre 1000/1000Mbps SME FTTB - Metrofibre By Wondernet",
    Price: 3179.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 1024000,
    Supplier: "Metro Fibre",
    ISP: "Wondernet"
  }
];